<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect
      x="4.25"
      y="1.75"
      width="7.5"
      height="12.5"
      rx="3.75"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.25"
    />
    <path
      d="M8 4.5V7"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'MouseIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>
